import { CHANGE_HEADER_CONTENT } from "./actionTypes";

export const fetchHeaderContent =
  (title, description, metaKey) => async (dispatch, getState) => {
    dispatch({
      type: CHANGE_HEADER_CONTENT,
      description: description,
      title: title,
      metaKey: metaKey,
    });
  };
